import { render, staticRenderFns } from "./ModalGroupCategoryEdit.vue?vue&type=template&id=555de21b&scoped=true"
import script from "./ModalGroupCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupCategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupCategoryEdit.vue?vue&type=style&index=0&id=555de21b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555de21b",
  null
  
)

export default component.exports